import { render, staticRenderFns } from "./DetectReportPage.vue?vue&type=template&id=659fa24c&scoped=true&"
import script from "./DetectReportPage.vue?vue&type=script&lang=js&"
export * from "./DetectReportPage.vue?vue&type=script&lang=js&"
import style0 from "./DetectReportPage.vue?vue&type=style&index=0&id=659fa24c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659fa24c",
  null
  
)

export default component.exports